import moment from 'moment'

export const Convert24hrTo12hr = time => {
  return moment(time, 'HH:mm:ss').format('hh:mm A')
}
